import { render } from "./ImageCarouselAbout.vue?vue&type=template&id=768d2a14&scoped=true"
import script from "./ImageCarouselAbout.vue?vue&type=script&lang=js"
export * from "./ImageCarouselAbout.vue?vue&type=script&lang=js"

import "./ImageCarouselAbout.vue?vue&type=style&index=0&id=768d2a14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768d2a14"]])

export default __exports__